import { IconSearch16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SearchIcon.css';

export const SearchIcon = () => {
  return (
    <div className={styles['search-icon']}>
      <IconSearch16 color="primary_100" />
    </div>
  );
};
